import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VerificationMethodSelectionPageComponent } from './verification-method-selection-page/verification-method-selection-page.component';
import { PasswordRecoveryModule } from '../password-recovery/password-recovery.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialAngularModule } from '../material-design/material.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { NgOtpInputModule } from 'ng-otp-input';
import { ComponentsModule } from '../shared/components/components.module';
import { TokenConfirmationPageComponent } from './token-confirmation-page/token-confirmation-page.component';
import { PasswordChangePageComponent } from './password-change-page/password-change-page.component';
import { AccountRecoveryPageComponent } from './account-recovery-page/account-recovery-page.component';

@NgModule({
  declarations: [VerificationMethodSelectionPageComponent, TokenConfirmationPageComponent, PasswordChangePageComponent, AccountRecoveryPageComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialAngularModule,
    ReactiveFormsModule,
    SharedDirectivesModule,
    NgOtpInputModule,
    PasswordRecoveryModule,
    ComponentsModule,
  ]
})
export class PasswordRecoveryExternalModule { }
